module.exports = __webpack_public_path__ + "img/ntpp3-2.0a91b2bb.png";